/**
 * Outside click Event Listener for Share Dialog.
 */

/**
 * Create an outside click listener for closing the share dialog.
 *
 * @param {HTMLElement} shareDialog Share dialog element.
 * @param {HTMLElement} shareButton Share button element.
 * @param {function} closeDialog Close dialog function.
 */
export function createOutsideClickListener( shareDialog, shareButton, closeDialog ) {
	return function outsideClickListener( e ) {
		if (
			! e?.target
			|| ! shareDialog?.contains( e.target ) && ! shareButton?.contains( e.target )
		) {
			closeDialog();
		}
	};
}
